import React, {Component} from "react";

const CHECK_TYPE_EIC = 1;

export default class DefineApplicationStep extends Component {
    constructor() {
        super(...arguments);

        this.state = {
            eic: sessionStorage.getItem('eic') ?? '',
            fail: false,
        }

        this.next = this.next.bind(this);
    }

    next() {
        sessionStorage.removeItem('eic');

        axios.get('/gas/check-status', {
            params: {
                type: CHECK_TYPE_EIC,
                identifier: this.state.eic,
            }
        })
            .then((resp) => {
                this.setState({fail: false});

                const {id, status_id, full_name, phone_number, address, need_documents} = resp.data;
                this.props.setData(id, status_id, full_name, phone_number, address, need_documents);
                this.props.moveNext();
            })
            .catch((error) => {
                this.setState({fail: true})
            })
    }

    render() {
        const {eic, fail} = this.state;

        return (
            <div className="define-application">
                <div className="header">
                    <h1>{window.translates.add_docs.define_step.header}</h1>
                </div>
                <div className="info my-5">
                    <h3 className="font-weight-bolder">{window.translates.add_docs.define_step.warn}</h3>
                    <p className="my-4">{window.translates.add_docs.define_step.info}</p>
                </div>
                <div className="input my-5">
                    <div className="form-group text-left">
                        <label htmlFor="eic">{window.translates.add_docs.define_step.eic_label}</label>
                        <input type="text" className="form-control"
                               placeholder="56X"
                               value={eic}
                               onChange={(e) => this.setState({eic: e.target.value})}
                        />
                    </div>
                    {fail &&
                        <div className="text-center p-4 border-top">
                            <p className="text-danger">{window.translates.add_docs.define_step.fail_message}</p>
                        </div>
                    }
                    <button className="btn btn-site btn-warning mt-3"
                            onClick={this.next}
                            disabled={!eic}
                    >
                        {window.translates.add_docs.define_step.next_button}
                    </button>
                </div>
            </div>
        )
    }
}
